export function splitTime(timeInSeconds, framerate){
  const hours = Math.floor(timeInSeconds / (60 * 60));
  const minutes = Math.floor((timeInSeconds % (60 * 60)) / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  let partials = (Math.round((timeInSeconds % 1) * 1000) / 1000); // Round to the first 3 digits.
  let partialsLength = 0;

  if (framerate) {
    partials = Math.floor(partials * framerate);
    partialsLength = 2;
  } else {
    partials = partials * 1000;
    partialsLength = 3;
  }
  let pad = (num, size) => ('000000000' + num).substr(-size);

  return [
    pad(hours, 2),
    pad(minutes, 2),
    pad(seconds, 2),
    pad(partials, partialsLength)
  ];
}
